var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0 py-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',[_c('SaRequestForm',{attrs:{"propsSaNo":_vm.saNo}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }